import styled from '@emotion/styled'
import { checkAmountRemaining, formatDollars } from '@open-tender/utils'
import {
  selectBrand,
  selectCheckout,
  selectOrder,
  selectRecaptcha,
  setRecaptchaToken,
  setSubmitting,
  submitOrder,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import { Button, ButtonLink, Message } from 'components'
import CheckoutSection from './CheckoutSection'
import FreedomPay from '../../FreedomPay'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

const CheckoutSubmitButton = styled.div`
  display: flex;
  justify-content: flex-start;
  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    justify-content: center;
  }
`

const CheckoutSubmitMessage = styled.div`
  margin: 3rem 0 0;

  > div {
    margin: 0 0 3rem;
  }
`

export const FreedomPayContainer = styled(FreedomPay)`
  margin-top: 3.2rem;
`

const CheckoutSubmitSave = styled.div`
  margin: 3rem 0 0;
`

const CheckoutSubmit = () => {
  const dispatch = useAppDispatch()
  const { orderType } = useAppSelector(selectOrder)
  const { require_cardholder_name = false, use_enterprise_recaptcha } =
    useAppSelector(selectBrand) || {}
  const { check, form, submitting, loading } = useAppSelector(selectCheckout)
  const { addCard: includeRecaptcha } = useAppSelector(selectRecaptcha) || {
    addCard: false,
  }
  const updating = submitting ? false : loading === 'pending'
  const total = check?.totals.total
  const deposit = check?.deposit
  const amountDue = deposit || total
  const amountRemaining = amountDue
    ? checkAmountRemaining(amountDue, form.tenders)
    : 0.0
  const isPaid = Math.abs(amountRemaining).toFixed(2) === '0.00'
  const submitDisabled =
    submitting ||
    !isPaid ||
    updating ||
    (includeRecaptcha && !use_enterprise_recaptcha && !form.token)
  const hasTotal = !!(amountDue && parseFloat(amountDue) >= 0)
  const totalAmount = hasTotal ? ` ${formatDollars(amountDue ?? '0')}` : ''
  const { executeRecaptcha } = useGoogleReCaptcha()

  const submitPayment = async () => {
    if (includeRecaptcha) {
      const token = await executeRecaptcha?.('addCard')
      dispatch(setRecaptchaToken(token))
    }
    dispatch(setSubmitting(true))
    dispatch(submitOrder())
  }

  const saveForLater = () => {
    dispatch(setSubmitting(true))
    dispatch(submitOrder({ save: true }))
  }

  return (
    <CheckoutSection>
      <CheckoutSubmitMessage>
        {!isPaid ? (
          <Message
            as="div"
            size="small"
            color="alert"
            style={{ width: '100%', padding: '1rem 1.5rem' }}
          >
            There is a balance of ${amountRemaining.toFixed(2)} remaining on
            your order. Please add a payment above.
          </Message>
        ) : null}
      </CheckoutSubmitMessage>
      <CheckoutSubmitButton>
        <Button
          onClick={submitPayment}
          disabled={submitDisabled}
          size="big"
          color="primary"
        >
          {updating ? 'Updating...' : `Submit Order${totalAmount}`}
        </Button>
      </CheckoutSubmitButton>
      {orderType === 'CATERING' ? (
        <CheckoutSubmitSave>
          <ButtonLink onClick={saveForLater}>
            Or save this order for later (your payment method will not be
            charged).
          </ButtonLink>
        </CheckoutSubmitSave>
      ) : null}
      {require_cardholder_name && <FreedomPayContainer />}
    </CheckoutSection>
  )
}

export default CheckoutSubmit
